module.exports = __webpack_public_path__ + "static/media/vidyabharathi.f414db25.png";